import BaseListPage from "../../../../../base/BaseListPage";
import dialog from "../../../../../components/Modal/dialog";
import PageContainer from "../../../../../components/PageContainer/PageContainer";
import Search from "../../../../../components/Search";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import createPromise from "../../../../../utils/createPromise";
import withRouter from "../../../../../utils/withRouter";
import PendingListPresenter from "./PendingListPresenter";
import StartDateModal from "./components/StartDateModal";

class PendingListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PendingListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      startDate: "",
      loading: true,
      total: 0,
      count: 0,
    };

    this.fieldsToDisplay = ["username", "affiliate", "branch"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "users";
  }

  formatSchema(fields) {
    return {
      ...fields,
      affiliate: {
        type: "String",
        label: "Client Code",
      },
      branch: {
        type: "String",
        label: "Branch Code",
      },
      username: {
        ...fields.username,
        _type: "String",
      },
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      return {
        ...object,
        affiliate: object.affiliate?.code,
        branch: object.branch?.code,
      };
    });
  }

  showAdditionalInformationModal(object, onChange) {
    const promise = createPromise();
    dialog.fire({
      html: <StartDateModal object={object} onChange={onChange} />,
      positiveButton: "Approve",
      onPositiveClick: () => {
        promise.resolve();
      },
      onNegativeClick: () => {
        promise.reject();
      },
    });

    return promise;
  }

  onClickView(index) {
    this.presenter.onClickView(index);
  }

  onClickApprove(index) {
    this.presenter.onClickApprove(index);
  }

  setStartDate(startDate) {
    this.setState({ startDate });
  }

  getActions() {
    return [
      {
        label: "View",
        onClick: this.onClickView.bind(this),
        icon: "",
        classes: "btn-secondary",
      },
      {
        label: "Approve",
        onClick: this.onClickApprove.bind(this),
        icon: "bi bi-check2",
      },
    ];
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    return (
      <PageContainer
        title="Pending Users"
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <div className="d-flex flex-column gap-4">
          <Search
            schemas={this.getSchemas()}
            className="w-50"
            onSubmit={this.searchSubmit.bind(this)}
            fields={schema.fields}
          />
          <Table
            fields={this.formatSchema(schema.fields)}
            objects={this.formatObjects(objects)}
            collapsable
            progress={loading}
            actions={this.getActions.bind(this)}
            excludeFields={Object.keys(schema.fields).filter(
              (key) => !this.fieldsToDisplay.includes(key)
            )}
          />
        </div>
      </PageContainer>
    );
  }
}

export default withRouter(PendingListPage);
